import React from "react";
import {
  SEO,
  PageLayout,
  Background,
  HookComponentProvider,
  ContactForm,
  createDefaultMessageFromState,
  LocationSelect,
  OutboundLink,
  LocationsContext,
} from "@bluefin/components";
import { useContext } from "react";
import { Grid, Header, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class ContactPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout className={"contact-page"} hero={null}>
          <Background columns={1} stackable={true} className={"contact-hero"}>
            <Background.Image
              images={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentName: "HeroElement",
              })}
              forceChildren={true}
            >
              <div className={"contact-form-container"}>
                <HookComponentProvider
                  hook={useContext}
                  component={
                    <div className={"pay-button-container"}>
                      <ContactForm
                        constructMessage={createDefaultMessageFromState}
                        buttonText={"Submit"}
                        centeredHeaders={false}
                        hideOptIn={false}
                        className={""}
                        fluidButton={true}
                        header={
                          <Grid
                            columns={2}
                            stackable={true}
                            className={"contact-form-header"}
                          >
                            <Grid.Column>
                              <Header as={"div"} className={"h1"}>
                                Contact
                              </Header>
                            </Grid.Column>
                            <Grid.Column>
                              <LocationSelect
                                useContext={true}
                                search={false}
                              />
                            </Grid.Column>
                          </Grid>
                        }
                        inline={false}
                        showLabels={true}
                        subheader={""}
                        termsCopy={""}
                        withContainer={false}
                        businessId={fishermanBusiness._id}
                        businessType={fishermanBusiness.type}
                        destinationEmail={"steve@atchanas.com"}
                        fields={[
                          {
                            label: "name",
                            placeholder: "Full Name",
                            type: "input",
                            required: true,
                          },
                          {
                            label: "email",
                            placeholder: "Email",
                            type: "input",
                            inputType: "email",
                            required: true,
                          },
                          {
                            label: "phone",
                            placeholder: "Phone Number",
                            type: "input",
                            required: true,
                          },
                          {
                            label: "contactReason",
                            displayLabel: "Contact Reason",
                            type: "select",
                            required: true,
                            options: [
                              {
                                label: "General Inquiry",
                                value: "General Inquiry",
                              },
                              {
                                label: "Spice Challenge Registration",
                                value: "Spice Challenge Registration",
                              },
                            ],
                          },
                          {
                            displayLabel: "Message",
                            label: "message",
                            placeholder: "Message",
                            type: "textarea",
                            required: true,
                          },
                        ]}
                      />
                      <Button
                        primary={true}
                        size={"large"}
                        to={
                          "https://connect.intuit.com/pay/Atchanas/scs-v1-7fdb1864acd142d7b2700404ea981cdbf260b328990a4481b8238068275f7cb1d7c9230f61f6406ba7633b9f5c3f301c?locale=EN_US&cta=paylinkbuybutton"
                        }
                        as={OutboundLink}
                      >
                        PAY $35
                      </Button>
                    </div>
                  }
                  hookToPropsMap={{ locationId: "activeLocation.id" }}
                  hookParams={[LocationsContext]}
                />
              </div>
            </Background.Image>
          </Background>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Contact" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
